import React, { useState, useEffect } from 'react';
import RootAdmin from '../../../../components/layouts/RootAdmin'
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Chip,
    DatePicker,
    Divider,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownTrigger,
    Tabs,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableColumn,
    TableHeader,
    TableRow
} from '@nextui-org/react'
import HeaderPage from '../../../../components/elements/HeaderPage'
import { ArrowDownOnSquareIcon, ArrowPathIcon, CheckIcon, ClockIcon, DocumentArrowUpIcon, DocumentDuplicateIcon, DocumentPlusIcon, FunnelIcon, ListBulletIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { BarChart } from '@mui/x-charts/BarChart';
import { SparkLineChart } from '@mui/x-charts'
import CountWidget from '../../../../components/elements/CountWidget'
import CustomDataGrid from "../../../../components/elements/CustomDataGrid";
import useSWR from "swr";
import { HIGHCHART_URL, getFetcher } from "../../../../services/api";
import ControlledInput from "../../../../components/elements/ControlledInput";
import {useForm} from "react-hook-form";
import FilterInTab from '../../../../components/elements/FilterInTab';
import { translateMonth } from '../../../../services/helpers';
import Highcharts from "highcharts";
import HighchartsReact from 'highcharts-react-official';
import highchartsExporting from 'highcharts/modules/exporting';
import { isiSel, kelasKolom, kelasKolomDariData } from "../../../../services/angkaTabel";

// Initialize Highcharts exporting modules
highchartsExporting(Highcharts);

export default function ProdusenGrafik() {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [b3Data, setB3Data] = useState([]);
    const [companyData, setCompanyData] = useState([]);
    const currentDate = new Date();
    const defaultMonth = currentDate.getMonth() + 1;
    const defaultYear = currentDate.getFullYear();
  
    const [filters, setFilters] = useState({
        provinsiTahun: { year: defaultYear },
      provinsiBulanTahun: {  month: defaultMonth, year: defaultYear  },
    });
  
    const updateFilter = (key, newFilter) => {
      setFilters((prev) => ({
        ...prev,
        [key]: { ...prev[key], ...newFilter },
      }));
    };

    // Fetch data grafik bahan b3 & perusahaan terbanyak
    const { data: produsenB3, mutate: mutateProdusenB3 } = useSWR(
        `/api/dashboard/pelaporan/Produsen/grafik/bahanb3?startDate=${startDate}&endDate=${endDate}`,
        getFetcher
    );

    const { data: produsenPerusahaan, mutate: mutateProdusenPerusahaan } = useSWR(
        `/api/dashboard/pelaporan/Produsen/grafik/perusahaan?startDate=${startDate}&endDate=${endDate}`,
        getFetcher
    );

    const { data: dataProduksiPronvisiBulanTahun, mutate: mutateDataProduksiPronvisiBulanTahun } = useSWR(
        `/api/dashboard/pelaporan/Produsen/grafik/total-production-per-month-year?month=${filters?.provinsiBulanTahun?.month}&year=${filters?.provinsiBulanTahun?.year}`,
        getFetcher
      );
    
      const { data: dataProduksiPronvisiTahun, mutate: mutateDataProduksiPronvisiTahun } = useSWR(
        `/api/dashboard/pelaporan/Produsen/grafik/total-production-per-year?year=${filters?.provinsiTahun?.year}`,
        getFetcher
      );

    const hanleTabFilter = (key, filter) => {
        updateFilter(key, filter);
    
        switch (key) {
          case "provinsiBulanTahun":
            mutateDataProduksiPronvisiBulanTahun();
            break;
          case "provinsiTahun":
            mutateDataProduksiPronvisiTahun();
            break;
          default:
            break;
        }
      };

    // masukkan ke data usestate setiap data baru ter-fetch
    useEffect(() => {
        console.log(produsenB3)
        if (produsenB3) {
            setB3Data(produsenB3.responseData.map(item => ({
                casNumber: item.casNumber,
                name: item.namaBahanKimia,
                total: item.total
            })));
        }

        if (produsenPerusahaan) {
            setCompanyData(produsenPerusahaan.responseData.map(item => ({
                name: item.name,
                total: item.total
            })));
        }
    }, [produsenB3, produsenPerusahaan]);

    const handleFilterApply = (start, end) => {
        setStartDate(start);
        setEndDate(end);
        mutateProdusenB3(); // Refresh data for produsenB3
        mutateProdusenPerusahaan(); // Refresh data for produsenPerusahaan
    };

    const renderHighchartsBarWithTable = (title, xAxisData, seriesData, tableData, tableHeaders) => {
        const options = {
            chart: {
                type: "column",
            },
            title: {
                text: title,
            },
            xAxis: {
                categories: xAxisData,
                title: {
                    text: null,
                },
            },
            yAxis: {
                min: 0,
                title: {
                    text: "Jumlah",
                    align: "high",
                },
                labels: {
                    overflow: "justify",
                },
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true,
                    },
                },
            },
            series: [
                {
                    name: "Jumlah",
                    data: seriesData,
                },
            ],
            exporting: {
                url: HIGHCHART_URL,
                enabled: true,
                showTable: true,
            },
        };

        return (
            <>
                <HighchartsReact highcharts={Highcharts} options={options} />
                <div className="col-span-4 mt-5">
                    <Table aria-label="Data Table">
                        <TableHeader>
                            {tableHeaders?.map((header, idx) => (
                                <TableColumn key={idx}>{header}</TableColumn>
                            ))}
                        </TableHeader>
                        <TableBody>
                            {tableData?.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell>{item.name}</TableCell>
                                    <TableCell>{item.total}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </>
        );
    };

    const renderHighchartsBar = (title, xAxisData, seriesData, label) => {
        const options = {
            chart: {
                type: "column",
            },
            title: {
                text: title,
            },
            xAxis: {
                categories: xAxisData,
                title: {
                    text: label,
                },
            },
            yAxis: {
                min: 0,
                title: {
                    text: "Jumlah",
                    align: "high",
                },
                labels: {
                    overflow: "justify",
                },
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true,
                    },
                },
            },
            series: [
                {
                    name: "Jumlah",
                    data: seriesData,
                },
            ],
            exporting: {
                url: HIGHCHART_URL,
                enabled: true,
                showTable: true,
            },
        };

        return <HighchartsReact highcharts={Highcharts} options={options} />;
    };

    return (<RootAdmin>
            <HeaderPage
                title="Grafik Pelaporan Produsen"
                subtitle="Gambaran Umum"
                action={<FilterForm onApplyFilter={handleFilterApply}/>}
            />
            <div className='grid grid-rows-1 md:grid-rows-4 gap-3 pt-5'>
                <Card>

                    <Tabs aria-label="Pelaporan Grafik B3" defaultValue="PelaporanGrafik">
                        <Tab title="Grafik Besaran B3 Terbanyak" value="B3Terbanyak">
                            <Card radius='sm' className='col-span-4'>
                                <CardHeader>
                                    <span className='text-primary text-xl font-bold'>10 Bahan B3 Terbanyak</span>
                                </CardHeader>
                                <CardBody className='w-full'>
                                {renderHighchartsBar(
                                        "10 Bahan B3 Terbanyak Di Produksi",
                                        b3Data?.map(item => item.name) ?? [],
                                        b3Data?.map(item => Number(item.total) || 0) ?? [],
                                        'Bahan B3'
                                    )}
                                </CardBody>
                            </Card>
                            <div className='col-span-4'>
                                <Table aria-label="Example static collection table">
                                    <TableHeader>
                                        <TableColumn>Nomor CAS</TableColumn>
                                        <TableColumn>Jenis B3</TableColumn>
                                        <TableColumn className="text-right">Jumlah</TableColumn>
                                    </TableHeader>
                                    <TableBody>
                                        {b3Data?.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{item.casNumber || "-"}</TableCell>
                                                <TableCell>{item.name}</TableCell>
                                                <TableCell className="text-right tabular-nums">
                                                    {isiSel("jumlah", item.total)}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </Tab>
                        <Tab title="Grafik Produksi B3 Berdasarkan Perusahaan" value="B3TerbanyakPerusahaan">
                            <Card radius='sm' className='col-span-4'>
                                <CardHeader>
                                    <span className='text-primary text-xl font-bold'>10 Jenis B3 Terbanyak Berdasarkan Perusahaan</span>
                                </CardHeader>
                                <CardBody className='w-full'>
                                {renderHighchartsBar(
                                        "10 Perusahaan Terbanyak Produksi",
                                        companyData?.map(item => item.name) ?? [],
                                        companyData?.map(item => Number(item.total) || 0) ?? [],
                                        'Nama Perusahaan'
                                    )}
                                </CardBody>
                            </Card>
                            <div className='col-span-4'>
                                <Table aria-label="Example static collection table">
                                    <TableHeader>
                                        <TableColumn>Perusahaan</TableColumn>
                                        <TableColumn className="text-right">Jumlah Produksi</TableColumn>
                                    </TableHeader>
                                    <TableBody>
                                        {companyData?.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{item.name}</TableCell>
                                                <TableCell className="text-right tabular-nums">
                                                    {isiSel("jumlah", item.total)}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </Tab>
                        <Tab title="Grafik Provinsi Terbanyak Per Bulan Tahun" value="provinsiBulanTahun">
                        <FilterInTab
                            filters={filters.provinsi}
                            onApply={(newFilters) => hanleTabFilter("provinsiBulanTahun", newFilters)}
                            disableMonth= {false}
                        />
                        {renderChartAndTableForRealisasi(
                                dataProduksiPronvisiBulanTahun?.responseData?.provinces,
                                "Grafik Produksi Bahan B3 Per Provinsi",
                                ["Tahun", "Provinsi", "Jumlah Produksi (Kg)"],
                                ["periode_tahun","province_name", "total_b3_used"],
                                "province_name",
                                "total_production"
                                )}
                        </Tab>
                        <Tab title="Grafik Provinsi Terbanyak Per Tahun" value="provinsiTahun">
                        <FilterInTab
                            filters={filters.provinsiTahun}
                            onApply={(newFilters) => hanleTabFilter("provinsiTahun", newFilters)}
                            disableMonth
                        />
                        {renderChartAndTableForRealisasi(
                                dataProduksiPronvisiTahun?.responseData?.provinces,
                                "Grafik Produksi Bahan B3 Per Provinsi",
                                ["Tahun", "Provinsi", "Jumlah Produksi (Kg)"],
                                ["periode_tahun","province_name", "total_production"],
                                "province_name",
                                "total_production"
                                )}
                        </Tab>
                    </Tabs>
                </Card>
            </div>
        </RootAdmin>)
}

function FilterForm({onApplyFilter}) {
    const { control, watch } = useForm({
        defaultValues: {
            startDate: "",
            endDate: "",
        },
    });
    const filters = watch();

    const handleApply = () => {
        onApplyFilter(filters.startDate, filters.endDate);
    };

    return (
        <Dropdown closeOnSelect={false}>
            <DropdownTrigger>
                <Button radius='sm' variant='bordered' startContent={<FunnelIcon className='size-4' />}>
                    Saring
                </Button>
            </DropdownTrigger>
            <DropdownMenu aria-label="Filter Date">
                <DropdownItem isReadOnly>
                    <ControlledInput
                        name="startDate"
                        label="Tanggal Mulai"
                        type="date"
                        control={control}
                        isRequired
                        rules={{
                            required: "Tanggal Mulai harus diisi.",
                        }}
                    />
                </DropdownItem>
                <DropdownItem isReadOnly>
                    <ControlledInput
                        name="endDate"
                        label="Tanggal Selesai"
                        type="date"
                        control={control}
                        isRequired
                        rules={{
                            required: "Tanggal Selesai harus diisi.",
                        }}
                    />
                </DropdownItem>
                <DropdownItem isReadOnly>
                    <Button size='sm' color='primary' onClick={handleApply}>
                        Terapkan
                    </Button>
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>
    );
}

function renderChartAndTableForRealisasi(data, title, columns, dataKeys, xAxisKey, seriesKey) {
    const safeData = Array.isArray(data) ? data : []; // Ensure data is an array

    // Prepare Highcharts options
    const options = {
        chart: {
            type: "column", // Changed to column for vertical bars
        },
        title: {
            text: title,
        },
        xAxis: {
            categories: safeData?.map((item) => item[xAxisKey] || "N/A"), // X-axis labels
            title: {
                text: null,
            },
        },
        yAxis: {
            min: 0,
            title: {
                text: "Jumlah",
                align: "high",
            },
            labels: {
                overflow: "justify",
            },
        },
        plotOptions: {
            column: {
                dataLabels: {
                    enabled: true,
                },
            },
        },
        series: [
            {
                name: "Jumlah",
                data: safeData?.map((item) => item[seriesKey] || 0), // Series data
            },
        ],
        exporting: {
            url: HIGHCHART_URL,
            enabled: true,
        },
    };

    return (
        <>
            <Card radius="sm" className="col-span-4">
                <CardHeader>
                    <span className="text-primary text-xl font-bold">{title}</span>
                </CardHeader>
                <CardBody className="w-full">
                    <HighchartsReact highcharts={Highcharts} options={options} />
                </CardBody>
            </Card>

            <div className="col-span-4 mt-5">
                <Table aria-label="Data Table">
                    <TableHeader>
                        {columns?.map((col, idx) => (
                            <TableColumn key={idx} className={kelasKolomDariData(dataKeys[idx], safeData)}>
                                {col}
                            </TableColumn>
                        ))}
                    </TableHeader>
                    <TableBody>
                        {safeData?.map((item, index) => (
                            <TableRow key={index}>
                                {dataKeys.map((key, idx) => (
                                    <TableCell key={idx} className={kelasKolom(key, item[key])}>
                                        {key === "periode_bulan"
                                            ? translateMonth(item[key]) || "N/A"
                                            : isiSel(key, item[key])}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
        </>
    );
}


// function renderChartAndTableForRealisasi(data, title, columns, dataKeys, dataGraphSeries, dataGraphxAxis) {
//     const safeData = Array.isArray(data) ? data : []; // Pastikan data adalah array
//     return (
//         <>
//             <Card radius="sm" className="col-span-4">
//                 <CardHeader>
//                     <span className="text-primary text-xl font-bold">{title}</span>
//                 </CardHeader>
//                 <CardBody className="w-full flex flex-col items-center py-5 text-center">
//                     <BarChart
//                         xAxis={[
//                             {
//                                 scaleType: "band",
//                                 data: safeData?.map((item) => item[dataGraphSeries] || "N/A"),
//                                 label: columns[0],
//                                 barGapRatio: 0,
//                                 categoryGapRatio: 0.4,
//                             },
//                         ]}
//                         series={[
//                             {
//                                 data: safeData?.map((item) => item[dataGraphxAxis] || 0),
//                             },
//                         ]}
//                         height={300}
//                     />
//                 </CardBody>
//             </Card>
  
//             <div className="col-span-4 mt-5">
//                 <Table aria-label="Data Table">
//                     <TableHeader>
//                         {columns?.map((col, idx) => (
//                             <TableColumn key={idx}>{col}</TableColumn>
//                         ))}
//                     </TableHeader>
//                     <TableBody>
//                         {safeData?.map((item, index) => (
//                             <TableRow key={index}>
//                                 {dataKeys.map((key, idx) => (
//                                     <TableCell key={idx}>
//                                         {key === "periode_bulan" 
//                                             ? translateMonth(item[key]) || "N/A" 
//                                             : item[key] || "N/A"}
//                                     </TableCell>
//                                 ))}
//                             </TableRow>
//                         ))}
//                     </TableBody>
//                 </Table>
//             </div>
//         </>
//     );
// }